import { render, staticRenderFns } from "./NewGrupo.vue?vue&type=template&id=4b6b5601&scoped=true"
import script from "./NewGrupo.vue?vue&type=script&lang=js"
export * from "./NewGrupo.vue?vue&type=script&lang=js"
import style0 from "./NewGrupo.vue?vue&type=style&index=0&id=4b6b5601&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6b5601",
  null
  
)

export default component.exports